export default {
      id: "one-up-drawer-open-integrated-usage",
      viewBox: "0 0 966 790",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#one-up-drawer-open-integrated",
      toString: function () {
        return this.url;
      }
    }